import React from 'react';
import { serviceOfferingIds, } from '../../../modules/Constants';
import WaterView from './WaterView';

const GrAdapter = () => (
  <WaterView serviceOfferingId={serviceOfferingIds.GR_WATER} />
);

export default GrAdapter;
